// Primitive (upload) video node is deprecated: media uploads now go through the
// unified `upload` node. This file is kept only so existing imports keep working
// and any legacy/primitive video node renders the Transform UI instead.
export { VideoTransform as VideoPrimitive } from './transform';
